import React, {useState} from 'react';

import {
    DataTypeProvider,
    SortingState,
    IntegratedSorting
} from '@devexpress/dx-react-grid';
import {
    Grid,
    Table,
    TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui';

import ProgressBar from '../../components/ProgressBar';
import HealthMonitorTableRowMenu from './HealthMonitorTableRowMenu';

import classes from './HealthMonitorTable.module.css';

const HealthMonitorTable = ({
    loading,
    onToggleCreateServiceRequestModal,
    rows
}) => {
    const [columns] = useState([
        { name: 'name', title: 'Name' },
        { name: 'snapshotRoute', title: 'Target' },
        { name: 'status', title: 'Status' },
        { name: 'priority', title: 'Priority' },
        { name: 'issueTypes', title: 'Issue Types' , getCellValue: fixList },
        { name: 'actions', title: ' ', getCellValue: getTableRowMenu }
    ]);

    const [tableColumnExtensions] = useState([
        { columnName: 'name', width: 250 },
        { columnName: 'snapshotRoute', width: 325 },
        { columnName: 'status', width: 'auto' },
        { columnName: 'priority', width: 'auto' },
        { columnName: 'issueTypes', width: 'auto' },
        { columnName: 'actions', width: 'auto' }
    ]);

    const [statusColumns] = useState(['status']);
    const [priorityColumns] = useState(['priority']);

    function fixList(rule) {
        return rule.issueTypes.join(', ');
    }

    function getTableRowMenu(rule) {
        return <HealthMonitorTableRowMenu rule={rule} onToggleCreateServiceRequestModal={onToggleCreateServiceRequestModal} />;
    }

    return (
        <div className={classes.HealthMonitorTable}>
            <Grid
                rows={rows}
                columns={columns}
            >
                <SortingState
                    defaultSorting={[
                        { columnName: 'status', direction: 'desc' },
                        { columnName: 'priority', direction: 'desc' }
                    ]}
                    columnExtensions={[{ columnName: 'actions', sortingEnabled: false }]}
                />
                <IntegratedSorting />
                <StatusTypeProvider
                    for={statusColumns}
                />
                <PriorityTypeProvider
                    for={priorityColumns}
                />
                <Table columnExtensions={tableColumnExtensions} />
                <TableHeaderRow showSortingControls />
            </Grid>
            {loading && <ProgressBar />}
        </div>
    );
};

const StatusTypeProvider = props => {
    const statusFormatter = ({ value }) => {
        switch (value) {
            case true:
                return 'Fault';
            case false:
                return 'Ok';
            default:
                return null;
        }
    };

    return (
        <DataTypeProvider
            formatterComponent={statusFormatter}
            {...props}
        />
    );
};

const PriorityTypeProvider = props => {
    const priorityFormatter = ({ value }) => {
        switch (value) {
            case 0:
                return 'Low';
            case 1:
                return 'Medium';
            case 2:
                return 'High';
            default:
                return null;
        }
    };

    return (
        <DataTypeProvider
            formatterComponent={priorityFormatter}
            {...props}
        />
    );
};


export default HealthMonitorTable;
